import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .then(() => {
    const loader = document.getElementById('global-loader');
    if (!loader) return;
    setTimeout(() => {
      loader.classList.add('hide');
      setTimeout(() => loader?.remove(), 1000);
    }, 200);
  })
  .catch(err => console.error(err));
